import cx from "classnames"
import React, { useEffect, useState, useRef } from "react"
import closeIcon from "./close-icon.svg"
import * as css from "./MobileCategoryFilter.module.css"

function MobileCategoryFilter({ className, categories, active, onSelectItem }) {
  const ref = useRef(null)

  const [isOpen, setIsOpen] = useState(false)

  const handleClearClick = (e) => {
    e.stopPropagation()

    setIsOpen(false)

    if (onSelectItem) {
      onSelectItem(null)
    }
  }

  const selectItem = (category) => {
    setIsOpen(false)

    if (onSelectItem) {
      onSelectItem(category)
    }
  }

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isOpen && ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside)

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [isOpen])

  return (
    <div className={cx(css.root, className)} ref={ref}>
      <div className={css.select} onClick={() => setIsOpen(!isOpen)}>
        <span className={cx({ [css.active]: !!active })}>
          {active ? active.toLowerCase() : "Select Category"}
        </span>
        {active ? (
          <div className={css.clearBtn} role="button">
            <img
              src={closeIcon}
              alt="Clear selection"
              onClick={handleClearClick}
            />
          </div>
        ) : (
          <span className={css.arrow} />
        )}
      </div>
      {isOpen && (
        <div className={css.dropdown}>
          <ul className={css.list}>
            {categories.map((category, index) => (
              <li
                className={css.item}
                onClick={() => selectItem(category)}
                role="button"
                key={index}
              >
                {category.toLowerCase()}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default MobileCategoryFilter
